// Need to use the React-specific entry point to import createApi
import { baseApi } from "./baseApi";

// using CSRF token from Local Storage

// Define a service using a base URL and expected endpoints
export const getAllApi = baseApi.injectEndpoints({
  reducerPath: "getAllApi",
  endpoints: (builder) => ({
    getAllClassEnrollment: builder.query({
      query: ({ search, limit, page  }) => {
        // const queryParams = new URLSearchParams(params).toString();
        return {
          url: `admin/class-enrollment?search=${search}&page=${page}&limit=${limit}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),
    getAllTrainingEnrollment: builder.query({
      query: ({ search, limit, page  }) => {
        // const queryParams = new URLSearchParams(params).toString();
        return {
          url: `admin/training-enrollment?search=${search}&page=${page}&limit=${limit}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),
    getAllTransaction: builder.query({
      query: ({ search, limit, page  }) => {
        // console.log(params)
        // const queryParams = new URLSearchParams(params).toString();
        // console.log(queryParams)
        return {
          url: `admin/transaction?search=${search}&page=${page}&limit=${limit}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),
    getAllSubscriber: builder.query({
      query: ({ search, limit, page  }) => {
        // const queryParams = new URLSearchParams(params).toString();
        return {
          url: `admin/subscribers?search=${search}&page=${page}&limit=${limit}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAllClassEnrollmentQuery,
  useGetAllTrainingEnrollmentQuery,
  useGetAllTransactionQuery,
  useGetAllSubscriberQuery,
} = getAllApi;
